import { FC, useLayoutEffect } from "react";
import { useConfig } from "./shared/hooks/useConfig";

export const HtmlTitle: FC = () => {
	const { productData } = useConfig();
	useLayoutEffect(() => {
		document.title = productData.htmlTitle;
	}, [productData]);

	return null;
};
